import { FC } from 'react'
import getTimestamp from 'helpers/date/getTimestamp'
import { SquarePen } from 'lucide-react'

type TEditedMobileBadge = {
  date: string
}

const EditedMobileBadge: FC<TEditedMobileBadge> = ({ date }) => (
  <div className="gap-xxs p-xxs flex text-gray-900 md:hidden">
    <SquarePen size={20} color="var(--gray-900)" />
    <div className="gap-xxxs flex flex-col text-base">
      <span className="font-medium leading-5 text-gray-900">Edited</span>
      <div className="text-gray-500">{getTimestamp(date)}</div>
    </div>
  </div>
)

export default EditedMobileBadge
